import React, { useEffect, useState } from "react";
import "./style.css";

const TypingAnimation = () => {
  const [text, setText] = useState("");
  const [phraseIndex, setPhraseIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);

  const phrases = [
    "Пам'ятаємо...",
    "Завдяки кожному з них — є кожен з нас!",
  ];

  const typingSpeed = 100;
  const pauseBetween = 1500;

  useEffect(() => {
    const currentPhrase = phrases[phraseIndex];

    if (charIndex < currentPhrase.length) {
      const timeout = setTimeout(() => {
        setText((prev) => prev + currentPhrase[charIndex]);
        setCharIndex((prev) => prev + 1);
      }, typingSpeed);

      return () => clearTimeout(timeout);
    } else {
      const timeout = setTimeout(() => {
        setText("");
        setCharIndex(0);
        setPhraseIndex((prev) => (prev + 1) % phrases.length);
      }, pauseBetween);

      return () => clearTimeout(timeout);
    }
  }, [charIndex, phraseIndex]);

  return (
    <div className="memory-frame">
      <div className="candle-icon">🕯️</div>
      <p className="typewriter-text">
        {text}
        <span className="cursor-blink"></span>
      </p>
      <div className="frame-line" />
    </div>
  );
};

export default TypingAnimation;